import { useDispatch, useSelector } from "react-redux";
import { createSlice } from "@reduxjs/toolkit";
import { useEffect } from "react";

const themeGet = localStorage.getItem("theme");
const initialTheme = themeGet ? themeGet : "light_mode";

export const themeSlice = createSlice({
    name: 'theme',
    initialState: {
        value: initialTheme
    },
    reducers: {
        toggleTheme: (state) => {
            const selectedTheme = state.value === "light_mode" ? "dark_mode" : "light_mode";
            state.value = selectedTheme;
            localStorage.setItem("theme", selectedTheme);
        }
    }
})

export const { toggleTheme } = themeSlice.actions;
export default themeSlice.reducer;


// Custom Hook
export const useTheme = () => {
    const dispatch = useDispatch();
    const theme = useSelector((state) => state.theme.value);
    
    useEffect(() => {
        const themeTag = document.querySelector("html");
        
        if(theme !== "light_mode") themeTag.classList.replace("light_mode", "dark_mode");
        else themeTag.classList.replace("dark_mode", "light_mode");
        
    }, [theme]);

    return { theme, toggleTheme: () => dispatch(toggleTheme()) };
}